module.exports = __webpack_public_path__ + "static/media/aeradvise.eb5cdbea.png";